<template>
    <div class="main">
        <report-top>
            <ly-search slot="search" v-model="searchItem.keyWork" @search="search"></ly-search></report-top>
        <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
                    class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button><Button
                    @click="openDel" class="chaxun">删除</Button></template>
        </selectTool>

        <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
            :height="utils.setTableHeight(200)">

            <template slot-scope="{ row, index }" slot="icon">
                <img :src="axios.platConfig.fileUri + 'mapicon/' + row.icon + '/4/1.gif'" style="width: 30px" />
            </template>

            <template slot-scope="{ row, index }" slot="action">
                <Button size="small" @click="opemUpdate(row, index)">编辑汇率</Button>

            </template>
        </Table>
        <div id="mypage">
            <div>
                <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]"
                    show-total show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange">
                </Page>
            </div>
        </div>
        <form-model :title="isAdd ? '新增汇率' : '编辑汇率'" width="400" ref="formModel">
            <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
        </form-model>
        <form-model title="删除汇率" width="400" ref="del">
            <Button slot="btn" type="primary" @click="del">提交表单</Button>
        </form-model>
        <form-model :title="isAdd ? '新增汇率' : '编辑汇率'" width="400" ref="genggai">
            <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
        </form-model>
    </div>
</template>

<script>
var kehuitems = [];
export default {
    data() {
        return {
            isAdd: false,
            columns: [
                {
                    type: "index",
                    width: 70,
                    align: "center",
                    sort: 0,
                },
                {
                    title: "外币名称",
                    key: "fromName",
                    sort: 3,

                },
                {
                    title: "本币名称",
                    key: "toName",
                    sort: 3,
                },
                {
                    title: "汇率",
                    key: "rate",
                    sort: 3,
                },
                {
                    title: "更新时间",
                    key: "updateTime2",
                    sort: 3,
                },
                {
                    title: "备注信息",
                    key: "remark",
                    sort: 3,
                },
                {
                    title: "操作",
                    slot: "action",
                    align: "center",
                    fixed: "right",
                    sort: 50,
                },
            ],
            tableData: [],
            item: {

                "cid": 0,
                rate: 1

            },

            searchItem: {
                "pageNumber": 1,
                "pageSize": 50,
                "type": 1,
                "cid": '',
                keyWork: ''
            },
            searchForms: [

                {
                    title: '客户名称',
                    key: 'cid',
                    type: 'Select',
                    selectType: 'obj',
                    selectItems: kehuitems,
                }
            ],
            total: 0,
            categorys: [],
            forms: [{
                title: '客户名称',
                key: 'cid',
                key2: 'customer',
                type: 'Select',
                selectType: 'obj',
                selectItems: kehuitems,
                span: 24,
                required: true,
            }],
            forms1: [{
                title: '汇率',
                key: 'rate',
                type: 'InputNumber',
                span: 24,
            }, {
                title: '外币名称',
                key: 'fromName',
                type: 'Input',
                readonly: true,
                span: 24,
            }, {
                title: '本币名称',
                key: 'toName',
                type: 'Input',
                readonly: true,
                span: 24,
            }],
            item1: {
                "id": 0,
                "rate": 0,
                "type": 0,
                "currencyFrom": "",
                "fromName": "",
                "cid": 0,
                "currencyTo": "",
                "remark": "",
                toName: ''
            }
        };
    },
    methods: {
        getList() {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-tms-server-base/rate/list",
                data: this.searchItem,
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                this.total = res.data.data.total;
                var data = res.data.data.dataList;
                for (let i = 0; i < data.length; i++) {
                    data[i].toName = '人民币'
                    data[i].updateTime2 = this.utils.time(data[i].updateTime)
                }
                this.tableData = data;
                console.log(data);
            });
        },
        addUpdate(name) {
            var a = this.$refs.formModel.getItem();
            if (!a) {
                return;
            }
            console.log(this.item);
            if (this.isAdd) {
                this.axios({
                    method: "post",
                    url: this.axios.ipPort + "/cloud-tms-server-base/rate/copyPublic",
                    data: this.item,
                }).then((res) => {
                    if (res) {
                        this.$refs.formModel.close();
                        this.getList();
                    }
                });
            } else {
                this.axios({
                    method: "post",
                    url: this.axios.ipPort + "/cloud-tms-server-base/rate/update",
                    data: this.item1,
                }).then((res) => {
                    if (res) {
                        this.$refs.genggai.close();
                        this.getList();
                    }
                });
            }
        },
        //删除公司
        del(row, n) {
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-tms-server-base/rate/deleteByCid",
                data: this.item,
            }).then((res) => {
                if (res) {
                    this.getList();
                    this.$refs.del.close();
                }
            });
        },

        //点击编辑按钮
        opemUpdate(row) {
            this.isAdd = false;
            for (const i in this.item1) {
                this.item1[i] = row[i];
            }
            this.item1.id = row.id;
            this.$refs.genggai.reach(this.forms1, this.item1);
        },
        openDel() {
            this.isAdd = true;
            this.$refs.del.reach(this.forms, this.item);
        },
        openAdd() {
            this.isAdd = true;
            this.$refs.formModel.reach(this.forms, this.item);
        },
        changePage(x) {
            this.searchItem.pageNumber = x;
            this.getList();
        },
        //每页总条数切换
        pageSizeChange(x) {
            this.searchItem.pageSize = x;
            this.getList();
        },
        search() {
            this.getList();
        },
        kehuList() {
            kehuitems.splice(0, 1000);
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
                data: {},
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                this.total = res.data.data.total;
                var data = res.data.data.dataList;

                for (let i = 0; i < data.length; i++) {
                    var obj = {
                        id: data[i].id,
                        name: data[i].name,
                    };
                    kehuitems.push(obj);
                }
                console.log(kehuitems);
            });
        },
        selectCartype(x) {
            this.selectIcon = x.value;
        },
        getSearchItem() {
            this.searchItem = this.$refs.selectTool.getItem();
            this.getList();
        },
    },
    mounted() {
        var config = {
            min: 100,
            max: 300,
        };
        this.columns = this.utils.cols(this.forms, this.columns);
        this.$refs.selectTool.reach(this.searchForms, this.searchItem);
        setTimeout(() => {
            this.getSearchItem();
        }, 200);
        this.kehuList();
    },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/huilvsiyou.vue